/* esm.sh - applesauce-signers@5.2.0/dist/interop */
export * from "/*applesauce-signers@5.2.0/esnext/dist/interop.mjs";
